/* eslint-disable prefer-arrow-callback,no-var,comma-dangle */
(async function Video() {
  function setupVideoPlayer(videoElement, callback) {
    if (typeof callback !== 'function') {
      callback = function () {};
    }

    var id = videoElement.getAttribute('id');
    if (!id) {
      id = [
        'video',
        videoElement.getAttribute('data-guid'),
        new Date().getTime().toString(36),
      ].join('-');
      videoElement.setAttribute('id', id);
    }

    // If the topic does not exist, that means we haven't even started to initate the player instance
    if (!window.tv2messages.getTopics()[id]) {
      // Call the tv2-player script function and create the actual player instance
      window.tv2player.create(videoElement).then(function _created(player) {
        // Publish the player instance to the topic, which will invoke the `callback` with the player instance
        window.tv2messages.publish(id, player);
      });
    }

    // Listen to when the player instance has been created, and invoke it with `callback`
    window.tv2messages.onceWithTimeout(id, 1e10, callback);
  }

  // @TODO: We will support both videos from mpx using the old player
  // and videos from brightcove. We may need to load both players to the page
  // at one time. Let's hope not, though.
  const videoElements = Array.prototype.slice.apply(
    window.document.querySelectorAll('.tc_video__video[data-guid][data-publisher="mpx"]'),
  );


  window.tv2 = window.tv2 || {};

  // Load the old player script
  if (videoElements.length) {
    const assetPrefix = document
      .querySelector("meta[name='asset-prefix']")
      .getAttribute('content');
    window.tv2.utils.loadScript(assetPrefix + 'player/player.3.1.7.js', () => {
      window.tv2messages.publish('tv2player.ready', setupVideoPlayer);
    });
  }

  // when the dom is ready
  function domready() {
    window.tv2messages.onceWithTimeout(
      'tv2player.ready',
      1e10,
      function (setupVideoPlayer) {
        Array.prototype.slice
          .apply(
            window.document.querySelectorAll('.tc_video__video[data-guid]'),
          )
          .forEach(function _video(playerElement) {
            setupVideoPlayer(playerElement);
            // createVideoCloseButton(playerElement);
            const closeButton = playerElement.querySelector('.tc_video__close');
            if(closeButton) {
              closeButton.addEventListener('click', () => {playerElement.classList.add('tc_video__video--hide')})
            }
          });
      },
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domready);
  } else {
    domready();
  }
})();
